import React from 'react';
import { Link } from 'react-router-dom';

function BrandLogo({ href }) {
    return (
        <Link to={href} className="flex items-center group">
            <img
                src="/brand/gameplaysync-mascot-ui.webp"
                alt="GameplaySync Mascot"
                width="56"
                height="56"
                decoding="async"
                className="w-14 h-14 rotate-6 -mr-3 z-10 relative transition-transform duration-300 group-hover:rotate-0"
            />
            <span className="gps-brand-wordmark gps-brand-wordmark--header relative">GameplaySync</span>
        </Link>
    );
}

export default BrandLogo;
